export const GET_FEEDBACKS_BY_ID = 'GET_FEEDBACKS_BY_ID';
export const GET_STATS_BY_ID = 'GET_STATS_BY_ID';
export const POST_FEEDBACK = 'POST_FEEDBACK';
